import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';

@Component({
    selector: 'app-control-error',
    templateUrl: './control-error.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ControlErrorComponent implements OnInit {

    constructor(private cdr: ChangeDetectorRef) { }

    // tslint:disable-next-line: variable-name
    _text: string;
    // tslint:disable-next-line: variable-name
    _hide = true;

    @Input() set text(value) {
        if (value !== this._text) {
            this._text = value;
            this._hide = !value;
            this.cdr.detectChanges();
        }
    }

    ngOnInit() {
    }

}
